import { Component, Input } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { Option } from "@recore-solutions/nstar-lib";

@Component({
	selector: "app-listing-status-select",
	templateUrl: "./listing-status-select.component.html",
	styleUrls: ["./listing-status-select.component.scss"],
})
export class ListingStatusSelectComponent {
	@Input() control: UntypedFormControl;

	listingStatusOptions: Option[];
	listingStatuses: { status: string; category: string; statusName: string; sortOrder: number }[] = [
		{
			status: "CANCL",
			category: "Cancelled",
			statusName: "Cancelled",
			sortOrder: 7,
		},
		{
			status: "CLOSD",
			category: "Closed",
			statusName: "Closed",
			sortOrder: 5,
		},
		{
			status: "EXP",
			category: "Expired",
			statusName: "Expired",
			sortOrder: 8,
		},
		{
			status: "I",
			category: "Incomplete",
			statusName: "Incomplete",
			sortOrder: 2,
		},
		{
			status: "RENTD",
			category: "Rented",
			statusName: "Rented",
			sortOrder: 6,
		},
		{
			status: "WE",
			category: "Withheld Expired",
			statusName: "Withheld Expired",
			sortOrder: 10,
		},
		{
			status: "W",
			category: "Withheld",
			statusName: "Withheld",
			sortOrder: 9,
		},
		{
			status: "COMPS",
			category: "Comp Sold",
			statusName: "Comp Sold",
			sortOrder: 5.5,
		},
		{
			status: "OAA",
			category: "Approval",
			statusName: "Office Approval Active",
			sortOrder: 11,
		},
		{
			status: "OAS",
			category: "Approval",
			statusName: "Office Approval Comp Sold",
			sortOrder: 12,
		},
		{
			status: "OAW",
			category: "Approval",
			statusName: "Office Approval Withheld",
			sortOrder: 13,
		},
		{
			status: "OACS",
			category: "Approval",
			statusName: "Office Approval Coming Soon",
			sortOrder: 14,
		},
		{
			status: "CSN",
			category: "Coming Soon",
			statusName: "Coming Soon",
			sortOrder: 14,
		},
		{
			status: "PEND",
			category: "Pending",
			statusName: "Pending",
			sortOrder: 3,
		},
		{
			status: "ACT",
			category: "Active",
			statusName: "Active",
			sortOrder: 0,
		},
		{
			status: "TNAFS",
			category: "TNAFS",
			statusName: "Temp Not Avail For Showing",
			sortOrder: 4,
		},
		{
			status: "ID",
			category: "Deleted",
			statusName: "Incomplete Deleted",
			sortOrder: 15,
		},
		{
			status: "WD",
			category: "Deleted",
			statusName: "Withheld Deleted",
			sortOrder: 15,
		},
		{
			status: "D",
			category: "Deleted",
			statusName: "Deleted",
			sortOrder: 15,
		},
	];

	constructor() {
		this.listingStatusOptions = this.mapStatusesToOptions(this.listingStatuses);
	}

	mapStatusesToOptionsMap(
		map,
		status: { status: string; category: string; statusName: string; sortOrder: number }
	): { [category: string]: string[] } {
		if (map[status.category]) {
			map[status.category].push(status.status);
		} else {
			map[status.category] = [status.status];
		}
		return map;
	}

	mapStatusesToOptions(
		statuses: { status: string; category: string; statusName: string; sortOrder: number }[]
	): Option[] {
		const map = statuses
			.sort((a, b) => a.sortOrder - b.sortOrder)
			.reduce(this.mapStatusesToOptionsMap, {});
		return Object.keys(map).map((k, i) => ({ value: k, key: map[k].join(","), sortOrder: i }));
	}
}
